import React from "react";
import { TierOptions } from "shared/AllDropDownOptions";
import { CustomDropDown } from "shared/AllInputs";
import { CustomViewInput } from "shared/AllViewInputs";
import CustomButton from "shared/CustomButton";
import { HandleAdd } from "utils/TableFunctions";
import AddMaintenanceCostTable from "views/RentSetup/Tables/AddMaintenanceCostTable";
import ViewMaintenaceCostTable from "../Tables/ViewMaintenanceCostTable";
import { initalAllMaintenanceInputs } from "../RentSetupForms/initialInputObjects";
import { getTierName } from "./functions";
const MaintenanceCost = ({
  type,
  data,
  handleChange,
  allValues,
  setAllValues,
}) => {

  const header = (
    <div className="flex flex-wrap justify-content-between w-full">
      <CustomDropDown
        data={data}
        name="tier"
        options={TierOptions}
        ignoreLabel
        extraClassName="px-0 w-10rem"
        col={3}
        className="w-full"
        onChange={({ name, value }) =>
          handleChange({ name: name, value: value, form: "maintenance" })
        }
      />
      <div className="flex justify-content-end flex-wrap">
        <CustomButton
          type="button"
          label="Add"
          onClick={() =>
            HandleAdd(initalAllMaintenanceInputs, allValues, setAllValues)
          }
        />
      </div>
    </div>
  );

  const viewHeader = (
    <div className="flex justify-content-between w-full">
      <CustomViewInput
        value={getTierName(data?.tier)}
        name="tier"
        ignoreLabel
        className="lg:w-20rem"
        col={12}
      />
    </div>
  );

  return (
    <>
      {type === "View" ? (
        <ViewMaintenaceCostTable
          header={viewHeader}
          allValues={allValues}
          setAllValues={setAllValues}
        />
      ) : (
        <AddMaintenanceCostTable
          customHeader={header}
          allValues={allValues}
          setAllValues={setAllValues}
        />
      )}
    </>
  );
};

export default MaintenanceCost;
